import { Get, Post } from '../request'

export const fetchNotices = () => {
  return Get('notices')
}

export const fetchMaintenanceNotices = ({ accessToken }) => {
  const config = {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    }
  }
  return Get('/mainte/notices', config)
}

export const updateMaintenanceNotice = ({ id, payload, accessToken }) => {
  const config = {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    }
  }
  return Post(`/mainte/notices/${id}`, payload, config)
}
